import { startCase } from 'lodash';

export const beautifyFieldsInQuotes = (text: string): string => {
  if (!text) {
    return '';
  }

  const parseQuote = (field: string, char: string) => `${char}${startCase(field)}${char}`;

  return text
    .replace(/"[^"]*"/gi, (match) => parseQuote(match, '"'))
    .replace(/'[^']*'/gi, (match) => parseQuote(match, "'"))
    .replace(/`[^`]*`/gi, (match) => parseQuote(match, '`'));
};

export const capitalizeFirstLetter = (str: string) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const capitalizeFirstLetterLowercaseOthers = (str: string) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const asArray = (input: string | string[]): string[] => (Array.isArray(input) ? (input as string[]) : [input as string]);

export const replaceEmptyStringsWithUndefined = (value: any): any => {
  if (Array.isArray(value)) {
    return value.map(replaceEmptyStringsWithUndefined);
  }
  if (value !== null && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, val]) => [key, val === '' ? undefined : replaceEmptyStringsWithUndefined(val)]),
    );
  }
  return value;
};
